import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import forOwn from "lodash/forOwn";
import isEmpty from "lodash/isEmpty";

/*----------------------------------------------------------------------------*/

function quitarColegioSeleccionado() {
  return actions.quitarColegioSeleccionado();
}

function resetDataSaved() {
  return actions.resetDataSaved();
}

/*----------------------------------------------------------------------------*/

function addPersonaContacto(datos) {
  return dispatch => {
    const ruta = "ventas/personas_de_contacto";
    const id = datos.isEdit ? datos.id : rootRef.child(ruta).push().key;

    delete datos.isEdit;
    let insert = {};
    insert[`${ruta}/${id}`] = { ...datos, id };
    rootRef.update(insert, () =>
      dispatch(
        actions.saveData({
          status: true,
          msg: "Contacto insertado"
        })
      )
    );
  };
}

function attachListenersPersonasContacto(idColegio = null) {
  return isEmpty(idColegio)
    ? null
    : dispatch => {
        dispatch(attachOnAddedPersonasContacto(idColegio));
        dispatch(attachOnRemovedPersonasContacto(idColegio));
        dispatch(attachOnChangedPersonasContacto(idColegio));
      };
}

function attachOnAddedPersonasContacto(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/personas_de_contacto")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_added",
        snap =>
          snap.hasChildren() &&
          dispatch(actions.addedPersonasContacto(snap.val()))
      );
}

function attachOnRemovedPersonasContacto(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/personas_de_contacto")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_removed",
        snap =>
          snap.hasChildren() &&
          dispatch(actions.removedPersonasContacto(snap.val()))
      );
}

function attachOnChangedPersonasContacto(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/personas_de_contacto")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_changed",
        snap =>
          snap.hasChildren() &&
          dispatch(actions.changedPersonasContacto(snap.val()))
      );
}

function detachListenersPersonasContacto() {
  return dispatch => {
    rootRef.child(`/ventas/personas_de_contacto`).off("child_added");
    rootRef.child(`/ventas/personas_de_contacto`).off("child_removed");
    rootRef.child(`/ventas/personas_de_contacto`).off("child_changed");
  };
}

function limpiarPersonasContacto() {
  return actions.limpiarPersonasContacto();
}

function borrarPersonaContacto({ idPersona }) {
  return dispatch =>
    rootRef.child(`ventas/personas_de_contacto/${idPersona}`).remove();
}

function esContactoPrincipal({ idColegio, idPersona }) {
  return dispatch =>
    rootRef
      .child(`ventas/personas_de_contacto`)
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .once("value", snap => {
        const contactos = snap.val();
        let insert = {};
        forOwn(contactos, (contacto, id) => {
          insert[`ventas/personas_de_contacto/${id}/forma_principal`] =
            idPersona === contacto.id;
        });
        rootRef.update(insert);
      });
}

/*---*/
export {
  attachListenersPersonasContacto,
  detachListenersPersonasContacto,
  addPersonaContacto,
  limpiarPersonasContacto,
  quitarColegioSeleccionado,
  resetDataSaved,
  borrarPersonaContacto,
  esContactoPrincipal
};



// WEBPACK FOOTER //
// ./src/ducks/ventasContactos/operations.js